export default {
  as_endorser_of_co_maker: 'As Endorser of Co-Maker',
  legal_claims_and_judgements: 'Legal Claims & Judgements',
  other_special_debt: 'Other Special Debt',
  provision_for_federal_income_tax: 'Provision for Federal Income Tax',
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/resources/contingentTypesMap.js